import { render } from "./ImgGallery.vue?vue&type=template&id=26079b48"
import script from "./ImgGallery.vue?vue&type=script&lang=js"
export * from "./ImgGallery.vue?vue&type=script&lang=js"

import "./ImgGallery.vue?vue&type=style&index=0&id=26079b48&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__